import axios from "@/utils/axiosHelper";

// 初始化数据(含授权)
export const onGetInitDataAPI = (params) => {
    return axios({ url: "/sword/spring/init", method: "GET", params }, { interceptResultCode: false });
};

// 抽奖
export const lotteryDataAPI = (params) => {
    return axios({ url: '/sword/spring/lottery', method: 'POST', params }, { interceptResultCode: false });
}

// 协助
export const assistanceDataAPI = (params) => {
    return axios({ url: '/sword/spring/help', method: 'POST', params }, { interceptResultCode: false });
}

// 帮助页初始化
export const onHelpInitAPI = (params) => {
    return axios({ url: '/sword/spring/help', method: 'GET', params }, { interceptResultCode: false })
}

// 注销
export const onLogoutAPI = (params) => {
    return axios({ url: "/game/my/disable", method: "POST", params }, { interceptResultCode: false });
};

// 渠道登陆
export const LoginByHjwqChannelAPI = (data) => {
    return axios({ url: "/sword/report/login", method: "POST", data });
};

// 免密登录
export const onGetFreeLoginAPI = (params) => {
    return axios({ url: '/game/login/free', method: 'POST', params }, { interceptResultCode: false })
}

// 领取cdk
export const onGetCdkAPI = (params) => {
    return axios({ url: '/sword/spring/cdk', method: 'POST', params }, { interceptResultCode: false })
}


// WEBPACK FOOTER //
// ./src/pages/hjwq/springFestival/api.js